import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { BookOpen, ArrowLeft } from 'lucide-react';
import glossaryTerms from '../data/glossaryTerms';

const GlossaryTermPage = () => {
  const { term } = useParams<{ term: string }>();
  const decodedTerm = term ? term.replace(/-/g, ' ') : '';

  const termData = glossaryTerms.find(
    (item) => item.term.toLowerCase() === decodedTerm.toLowerCase()
  );

  if (!termData) {
    return <div>Term not found</div>;
  }

  const firstLetter = termData.term[0].toUpperCase();

  const getTermUrl = (term: string) => {
    const formattedTerm = term.toLowerCase().replace(/\s+/g, '-');
    const letter = term[0].toLowerCase();
    return `/glossary/${letter}/${formattedTerm}`;
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <Link to={`/glossary/${firstLetter.toLowerCase()}`} className="text-indigo-600 hover:text-indigo-800 flex items-center mb-4">
        <ArrowLeft className="w-4 h-4 mr-2" />
        Back to {firstLetter} Terms
      </Link>
      <h1 className="text-3xl font-bold text-gray-800 mb-6 flex items-center">
        <BookOpen className="w-8 h-8 mr-2 text-indigo-600" />
        {termData.term}
      </h1>

      <div className="bg-white rounded-lg shadow-md p-6">
        <h2 className="text-xl font-semibold text-gray-700 mb-4">Definition</h2>
        <p className="text-gray-600 mb-6">{termData.definition}</p>

        <h2 className="text-xl font-semibold text-gray-700 mb-4">Example</h2>
        <p className="text-gray-600 mb-6">
          {termData.example || "No example available for this term."}
        </p>

        <h2 className="text-xl font-semibold text-gray-700 mb-4">Related Terms</h2>
        <ul className="list-disc list-inside text-gray-600">
          {termData.relatedTerms ? 
            termData.relatedTerms.map((relatedTerm, index) => (
              <li key={index}>
                <Link to={getTermUrl(relatedTerm)} className="text-indigo-600 hover:text-indigo-800">
                  {relatedTerm}
                </Link>
              </li>
            )) : 
            <li>No related terms available.</li>
          }
        </ul>
      </div>
    </div>
  );
};

export default GlossaryTermPage;